import { organizationAPI } from '../api/requests/organization/organizationAPI';
import { getOrgName } from './appendOrgQuery';
import { getCachedOrgRole, setCachedOrgRole } from './orgRoleCache';

const getRoleForOrganization = async() => {
  const fetchUserRole = async(org) => {
    // Check cache first
    const cached = getCachedOrgRole(org);
    if (cached) {
      return cached;
    }

    const response = await organizationAPI.getOrgRole(org);
    
    // Cache the response
    if (response) {
      setCachedOrgRole(org, response);
    }

    return response;
  };
  const orgName = getOrgName();
  const isPublicPage = window.location.pathname.startsWith('/p/');

  try {
    if (orgName && !isPublicPage) {
      const response = await fetchUserRole(orgName);

      if (response) {
        return response.role;
      }
      throw new Error('Organization data not found');
    }
  } catch (error) {
    if (!isPublicPage) {
      localStorage.clear();
      window.location.href = '/sign-in';
    } else {
      return null;
    }
  }
};

export default getRoleForOrganization;
